import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Button} from "devextreme-react/button";
import {Popover} from "devextreme-react";
import {Position} from "devextreme-react/popup";
import DataGrid, {Column, DataGridRef, Editing} from "devextreme-react/data-grid";
import IReservationAge from "../../models/IReservationAge";
import useApi, {IApiErreur} from "../../hooks/useApi";
import {ICustomRule} from "../../hooks/useCustomDataSource";
import IReservationDetailSommaire from "../../models/IReservationDetailSommaire";
import {useStorage} from "../../hooks/useStorage";
import {useQuery} from "@tanstack/react-query";;

interface GestionReservationTrancheAgePopupProps {
    id: any,
    adulte: any,
    border?: boolean | undefined,
    trancheAges: IReservationAge[] | undefined,
    isModeModifier: boolean,
    onTrancheAgeValueChanged?: () => void
}

const GestionReservaitonTrancheAgePopup = ({id, adulte, border = false, trancheAges, isModeModifier, onTrancheAgeValueChanged}: GestionReservationTrancheAgePopupProps) => {
    const [refresh, setRefresh] = useState(false)
    const {fetchData} = useApi<ICustomRule[]>("ReservationAge")
    //const [validationRules, setValidationRules, isExpired] = useStorage<ICustomRule[]>({key: "validationRules-reservationAge", storageType: "localStorage", defaultValue: [], expirationInMilliseconds: 1000 * 60 * 5});
    const dataGridRef = useRef<DataGridRef>(null);
    const [hasDataChanged, setHasDataChanged] = useState(false)
    const [hasError, setHasError] = useState(false);
    const {data: validationRules} = useQuery({
        queryKey: ["validationRules-reservationAge"], queryFn: async () => {
            return fetchData("get", {customPath: `reservationAge/getValidation`, returnOnly: true}).then((result: string[]) => {
                return result.map(fieldName => {
                    return {type: "async", message: "", reevaluate: true, propertyName: fieldName} as ICustomRule
                })
            })
        }
    })

    const validate = useCallback(async (data: IReservationDetailSommaire | undefined) => {
        setHasError(false)
        const result = await fetchData("post", {
            customPath: `reservationAge/ValidateModel`,
            body: data as unknown as object,
            returnOnly: true
        });
        return result as unknown[] as IApiErreur[];
    }, [fetchData]);

    const validationCallback = useCallback((e: any) => {
        return new Promise(async (resolve, reject) => {
            if (!isModeModifier) return resolve(undefined);
            try {

                const result: IApiErreur[] = await validate(e.data);
                const erreur = result.find(f => f.propertyName.toLowerCase() === e.rule.propertyName.toLowerCase())
                if (erreur) {
                    setHasError(true)
                    reject(erreur.errorMessage);
                }
            } catch (ex) {
                resolve(undefined);
            }
            resolve(undefined);
        })
    }, [isModeModifier, validate])

    const customizeColumns = useCallback((items: any) => {
        if (!isModeModifier || !validationRules || validationRules.length === 0) return;

        items.forEach((col: any) => {
            if (col.dataField) {
                const rule = validationRules.find(f => f.propertyName.toLowerCase() === col.dataField?.toLowerCase());
                if (rule) {
                    rule.validationCallback = validationCallback;
                    col.validationRules = [rule];
                }
            }
        });

    }, [validationRules, isModeModifier, validationCallback])

    function isValidationErreur(arg: any[]): arg is IApiErreur[] {
        const result = arg && arg.length > 0 && arg[0] && arg[0].propertyName && typeof (arg[0].propertyName) === 'string'
        return result;
    }

    if (!trancheAges) return null;

    return (
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", ...(border ? {border: "1px solid #e0e0e0"} : null)}}>
            <div><Button id={`btn-${adulte ? 'adulte' : 'enfant'}-${id}`} stylingMode={"text"}><b>+</b></Button></div>
            <div style={{flex: 1, textAlign: "center"}}>{trancheAges?.reduce((nb, age) => nb + age.nombrePersonnes, 0)}</div>
            <Popover onHidden={() => {
                if (hasDataChanged && onTrancheAgeValueChanged)
                    onTrancheAgeValueChanged()
            }} onHiding={(e) => {
                e.cancel = hasError;
            }} target={`#btn-${adulte ? 'adulte' : 'enfant'}-${id}`} width={"20rem"} height={"12rem"} showEvent={"click"}>
                <Position of={`#btn-${adulte ? 'adulte' : 'enfant'}-${id}`} my={"left top"} collision={"none"} offset="-50 -10"/>
                <DataGrid ref={dataGridRef} dataSource={trancheAges.filter(f => f.isAdulte == adulte)} customizeColumns={customizeColumns} repaintChangesOnly onRowUpdated={(e) => {
                    setRefresh(prev => !prev)
                    setHasDataChanged(true);
                }}>
                    <Editing allowAdding={false} allowDeleting={false} allowUpdating={isModeModifier} newRowPosition={"first"} mode={"cell"} startEditAction={"click"}/>
                    <Column allowEditing={false} dataField={"description"}/>
                    <Column showEditorAlways={isModeModifier} dataType={"number"} dataField={"nombrePersonnes"}/>
                </DataGrid>
            </Popover>
        </div>
    )
        ;
}
export default GestionReservaitonTrancheAgePopup;